<div class="modal-header">
    <h5 class="modal-title">Select a GIF</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body" (scroll)="onScroll($event)" style="max-height: 400px; overflow-y: auto;">
    <!--<input type="text" [(ngModel)]="searchTerm" (keyup)="search()" placeholder="Search GIFs" class="form-control mb-2">
    <button class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon04" (click)="searchTerm=''; search()">
        X
    </button>-->
    <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Search GIFs" [(ngModel)]="searchTerm" (keyup)="search()">
        <button class="btn btn-outline-secondary" type="button" id="clearInputButton" (click)="clearSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
        </button>
    </div>

    <div *ngIf="gifs">
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="autoPlayGIFs" [(ngModel)]="autoPlay" (change)="toggleAutoplay()">
            <label class="form-check-label" for="autoPlayGIFs">Auto-play GIFs</label>
        </div>
        <!--<div *ngFor="let gif of gifs.results" (click)="selectGif(gif)" class="gif-item">
            <img [src]="gif.media[0].tinygif.url" alt="gif" class="img-fluid">
        </div>-->
        <div *ngFor="let gif of gifs" (click)="selectGif(gif)" class="gif-item">
            <img *ngIf="!autoPlay" [src]="gif.media_formats.tinygifpreview.url" alt="{{ gif.content_description }}" class="img-fluid">
            <img *ngIf="autoPlay" [src]="gif.media_formats.tinygif.url" alt="{{ gif.content_description }}" class="img-fluid">
            <!--<video *ngIf="autoPlay" [src]="gif.media_formats.tinygif.url" autoplay loop muted playsinline class="img-fluid">
                Your browser does not support the video tag.
            </video>-->
            <!--<video [src]="gif.media_formats.tinygif.url" [attr.autoplay]="autoPlay ? 'autoplay' : null" loop muted playsinline class="img-fluid">
        Your browser does not support the video tag.
    </video>-->
            <!--<video src="{{ gif.media_formats.tinygif.url }}" [attr.autoplay]="autoPlay ? 'autoplay' : null" loop muted playsinline controls class="img-fluid">
        Your browser does not support the video tag.
    </video>-->
        </div>
    </div>
</div>
